import { AuthStorage } from './auth';
import { IStorageProvider } from './storageProvider.types';
import { IStore } from './store.types';

export const storageProvider = (store: IStore): IStorageProvider => ({
  auth: new AuthStorage(store),
});
